import React from 'react';
import { formatTime } from '@dataGrid/gridUtilities';
import ShipmentsList from './ShipmentsList';
import { withStyles } from '@material-ui/core';
import { formatAddress } from '../../../../Dispatch/utils/utils';

const styles = (theme) => ({
  container: {
    marginBottom: '28px'
  },
  customerInfo: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    color: theme.disableButtonText,
    marginBottom: '8px'
  },
  address: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    marginBottom: '12px'
  },
  detailsRowContainer: {
    display: 'flex',
    gap: '20px',
    marginBottom: '16px',
    fontSize: theme.textFontSize
  },
  detailsRowItem: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    '& span:nth-child(2)': {
      fontWeight: 'bold',
      color: theme.disableButtonText
    }
  },
  tableContainer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: '12px'
  }
});

const CustomerData = ({ classes, data }) => {
  const {
    customer,
    customerCode,
    routeName,
    deliveryWindow,
    shipmentDetails = [],
    stopDetails: { eta } = {}
  } = data;
  const detailsRow = [
    { label: 'Route', value: routeName ?? '-' },
    { label: 'ETA', value: eta ? formatTime({ value: eta }) : '-' },
    { label: 'Delivery Window', value: deliveryWindow ?? '-' }
  ];

  return (
    <div className={classes.container}>
      <div className={classes.customerInfo}>
        {customer} ({customerCode})
      </div>
      <div className={classes.address}>
        {formatAddress({
          address: data.consigneeAddress,
          city: data.city,
          state: data.state,
          zip: data.zip
        })}
      </div>
      <div className={classes.detailsRowContainer}>
        {detailsRow.map((info) => (
          <div key={info.label} className={classes.detailsRowItem}>
            <span>{info.label}</span>
            <span>{info.value}</span>
          </div>
        ))}
      </div>
      <ShipmentsList shipments={shipmentDetails} />
    </div>
  );
};

export default withStyles(styles)(CustomerData);
